var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUserLogs = function SvgUserLogs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288.427,
    height: 345.712,
    viewBox: "0 0 288.427 345.712",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-43 -268.292)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(43 268.292)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M170.3,166.53c22.878,0,42.689-8.205,58.876-24.395s24.392-35.992,24.392-58.873-8.205-42.681-24.395-58.873S193.174,0,170.3,0s-42.686,8.205-58.873,24.392S87.031,60.387,87.031,83.262s8.208,42.689,24.4,58.876S147.426,166.53,170.3,166.53Zm0,0",
    transform: "translate(-28.267 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M287.728,346.159a205.656,205.656,0,0,0-2.8-21.844,172.109,172.109,0,0,0-5.373-21.963,108.483,108.483,0,0,0-9.028-20.483,77.3,77.3,0,0,0-13.615-17.743,60.029,60.029,0,0,0-19.557-12.288,67.591,67.591,0,0,0-24.967-4.518c-3.529,0-6.942,1.448-13.533,5.739-4.057,2.645-8.8,5.705-14.1,9.089a80.782,80.782,0,0,1-18.241,8.037,70.833,70.833,0,0,1-44.622,0,80.593,80.593,0,0,1-18.228-8.034c-5.246-3.352-9.994-6.412-14.111-9.094-6.583-4.291-10-5.739-13.528-5.739A67.5,67.5,0,0,0,51.06,251.84,59.978,59.978,0,0,0,31.5,264.128a77.3,77.3,0,0,0-13.61,17.74,108.694,108.694,0,0,0-9.028,20.486,172.516,172.516,0,0,0-5.37,21.96,204.94,204.94,0,0,0-2.8,21.852C.232,352.782,0,359.647,0,366.581c0,18.046,5.737,32.656,17.049,43.43,11.173,10.632,25.956,16.026,43.934,16.026H227.444c17.978,0,32.756-5.391,43.931-16.026,11.315-10.767,17.052-25.379,17.052-43.433C288.425,359.613,288.19,352.742,287.728,346.159Zm0,0",
    transform: "translate(0 -80.325)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "LOGS",
    transform: "translate(77 560)",
    fontSize: 80,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "LOGS")))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUserLogs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user-logs.00906fe6.svg";
export { ForwardRef as ReactComponent };